import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-depoimento',
    templateUrl: './depoimento.component.html',
    styleUrls: ['./depoimento.component.scss']
})

export class DepoimentoComponent implements OnInit {
    @Input() data;

    constructor() {
    }

    ngOnInit() {
    }
}
